import React from 'react';
import { Text, Gutter, SubmitButton, Gap } from '@common/components';
import { Form, Radio } from 'antd';

export type PreAuthMembership = {
  id: string;
  role: string;
  entityName: string;
  entityCode: string | null;
};

type Props = {
  memberships: PreAuthMembership[];
  internalTrustedUser: boolean;
  loading?: boolean;
  onSelect: (membershipId: string) => void;
};

export function SignInMembershipPicker({
  memberships,
  internalTrustedUser,
  loading,
  onSelect,
}: Props) {
  const [form] = Form.useForm();

  const getEntityNameOrCode = (m: PreAuthMembership) => {
    if (internalTrustedUser && m.entityCode) return m.entityCode;
    return m.entityName;
  };

  const onFinish = (values: { membershipId: string }) => {
    onSelect(values.membershipId);
  };

  return (
    <div className="sign-in-membership-picker">
      <Text weight="bold">Select an account</Text>
      <Gutter size="sm" direction="bottom" />
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={{ membershipId: memberships[0]?.id }}
      >
        <Form.Item name="membershipId">
          <Radio.Group size="large">
            <Gap vertical>
              {memberships.map((m) => (
                <Radio key={m.id} value={m.id}>
                  {getEntityNameOrCode(m)}
                </Radio>
              ))}
            </Gap>
          </Radio.Group>
        </Form.Item>
        <Form.Item className="button-row">
          <SubmitButton loading={loading} className="sign-in-form-button">
            Sign In
          </SubmitButton>
        </Form.Item>
      </Form>
    </div>
  );
}
